import { GenerateDraftStepSummaryRequestSchema, GenerateDraftStepSummaryResponseSchema } from './generate-draft-step-summary.schema';
/**
 * Generate Draft Step Summary Endpoint Contract
 * Generate AI step summary (name + description) for a draft step.
 * Does not persist; caller decides whether to apply.
 */ export const generateDraftStepSummaryContract = {
    method: 'POST',
    path: '/api/v2/process/:processId/draft/steps/:stepId/generate-summary',
    description: 'Generate AI step summary (name + description) for a draft step. Does not persist; caller decides whether to apply.',
    requestSchema: GenerateDraftStepSummaryRequestSchema,
    responseSchema: GenerateDraftStepSummaryResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized',
            403: 'Forbidden',
            404: 'Draft step not found',
            500: 'AI generation failed'
        }
    }
};

//# sourceMappingURL=generate-draft-step-summary.contract.js.map